const ProcurementLocationType = {
  GET_PROCUREMENT_LOCATION_LIST: 'GET_PROCUREMENT_LOCATION_LIST',
  GET_PROCUREMENT_LOCATION_LIST_SUCCESS: 'GET_PROCUREMENT_LOCATION_LIST_SUCCESS',
  GET_PROCUREMENT_LOCATION_LIST_FAIL: 'GET_PROCUREMENT_LOCATION_LIST_FAIL',
  SET_PROCUREMENT_LOCATION_LIST_REQUEST: 'SET_PROCUREMENT_LOCATION_LIST_REQUEST',
  SET_ADD_NEW_LOCATION: 'SET_ADD_NEW_LOCATION',

  CREATE_UPDATE_PROCUREMENT_LOCATION: 'CREATE_UPDATE_PROCUREMENT_LOCATION',
  CREATE_UPDATE_PROCUREMENT_LOCATION_SUCCESS: 'CREATE_UPDATE_PROCUREMENT_LOCATION_SUCCESS',
  CREATE_UPDATE_PROCUREMENT_LOCATION_FAIL: 'CREATE_UPDATE_PROCUREMENT_LOCATION_FAIL',
  CREATE_UPDATE_PROCUREMENT_LOCATION_REQUEST_RESET: 'CREATE_UPDATE_PROCUREMENT_LOCATION_REQUEST_RESET',

  UPDATE_SELECTED_LOCATION: 'UPDATE_SELECTED_LOCATION',
  RESET_PROCUREMENT_LOCATION_LIST: 'RESET_PROCUREMENT_LOCATION_LIST',
  CLEAR_PROCUREMENT_LOCATION_CREATION: 'CLEAR_PROCUREMENT_LOCATION_CREATION',
  CHECK_SELECTED_LOCATION_VALUE_UPDATE: 'CHECK_SELECTED_LOCATION_VALUE_UPDATE',
};

export default ProcurementLocationType;
